import Text from './Text.vue';

export default Text;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/data/components/text/index.ts